/**
 * A fabricated or described customer exists nowhere live, so while such a case is on screen the simulator
 * runs Mocked and the tool mode cannot be switched. Another case releases it.
 */

import { useEffect } from 'react';
import { useAtom } from 'jotai';
import type { ScenarioKind } from '@/types/websocket.types';
import { simulateToolsAtom } from '../sidebar/simulation-profile.store';

const FABRICATED_HINT = 'Fabricated scenarios run on Mocked data';
const DESCRIBED_HINT = 'Described scenarios run on Mocked data';

/** Why the tool mode is fixed to Mocked; null while it is free. */
export const useToolModeLock = (kind: ScenarioKind | null, described = false): string | null => {
  const [simulateTools, setSimulateTools] = useAtom(simulateToolsAtom);
  const hint = kind === 'fabricated' ? FABRICATED_HINT : described ? DESCRIBED_HINT : null;

  useEffect(() => {
    if (hint && !simulateTools) setSimulateTools(true);
  }, [hint, simulateTools, setSimulateTools]);

  return hint;
};
